export const defaultColumns = [
  { label: "Nome da categoria", value: "display_name", className: "max-w-96" },
  { label: "Ações", value: "actions", className: "w-10" },
];
